import { chapterDetailsActionTypes } from './Constants';

const initialState = {
	loading: true,
	chapterDetails: {},
	chapterDetailsParagraphs: [],
	chapterDetailsSummary: {},
	loadingChapterDetails: true,
	loadingParagraphs: true,
	loadingSummary: true,
	loadingDiagnosticTest: true,
	pausedDiagnosticTest: null,
	toDoTopics: {},
	loadDiagnosticTestError: false,
	loadingRelatedQuestions: true,
	relatedQuestions: {
		results: [],
		total_count: null,
	},
};

export default function chapterDetailsReducer(state = initialState, action) {
	const { type, payload } = action;
	const { chapterDetails, chapterDetailsParagraphs, chapterDetailsSummary, toDoTopics, data } =
		payload || {};

	switch (type) {
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUCCESS:
			return {
				...state,
				chapterDetails,
				loadingChapterDetails: false,
			};

		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUMMARY:
			return {
				...state,
				loadingSummary: true,
			};
		case chapterDetailsActionTypes.GET_TO_DO_TOPICS:
			return {
				...state,
				loading: true,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_PARAGRAPHS:
			return {
				...state,
				loadingParagraphs: true,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_PARAGRAPHS_SUCCESS:
			return {
				...state,
				chapterDetailsParagraphs,
				loadingParagraphs: false,
				loading: false,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_PARAGRAPHS_ERROR:
			return {
				...state,
				loadingParagraphs: false,
				loading: false,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUMMARY_ERROR:
			return {
				...state,
				loadingSummary: false,
			};
		case chapterDetailsActionTypes.GET_TO_DO_TOPICS_ERROR:
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_DETAILS_SUMMARY_SUCCESS:
			return {
				...state,
				chapterDetailsSummary,
				loadingSummary: false,
			};
		case chapterDetailsActionTypes.GET_PAUSED_DIAGNOSTIC_TEST:
			return {
				...state,
				loadingDiagnosticTest: true,
			};
		case chapterDetailsActionTypes.GET_PAUSED_DIAGNOSTIC_TEST_SUCCESS:
			return {
				...state,
				...data,
				loadingDiagnosticTest: false,
			};
		case chapterDetailsActionTypes.GET_PAUSED_DIAGNOSTIC_TEST_ERROR:
			return {
				...state,
				loadingDiagnosticTest: false,
			};
		case chapterDetailsActionTypes.GET_TO_DO_TOPICS_SUCCESS:
			return {
				...state,
				toDoTopics,
				loading: false,
			};
		case chapterDetailsActionTypes.CLEAR_PARAGRAPHS_DATA:
			return {
				...state,
				loading: true,
				loadingParagraphs: true,
				chapterDetailsParagraphs: [],
			};
		case chapterDetailsActionTypes.CLEAR_SUMMARY_DATA:
			return {
				...state,
				loadingSummary: true,
				chapterDetailsSummary: {},
			};
		case chapterDetailsActionTypes.CLEAR_TODO_DATA:
			return {
				...state,
				loadingDiagnosticTest: true,
				chapterDetailsParagraphs: [],
				toDoTopics: {},
				loadDiagnosticTestError: false,
			};
		case chapterDetailsActionTypes.CLEAN_CHAPTER_DETAILS_STATE:
			return initialState;
		case chapterDetailsActionTypes.GET_CHAPTER_RELATED_QUESTIONS:
			return {
				...state,
				loadingRelatedQuestions: true,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_RELATED_QUESTIONS_SUCCESS:
			return {
				...state,
				loadingRelatedQuestions: false,
				relatedQuestions: data,
			};
		case chapterDetailsActionTypes.GET_CHAPTER_RELATED_QUESTIONS_ERROR:
			return {
				...state,
				loadingRelatedQuestions: false,
			};
		default:
			return state;
	}
}
